import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import {
  PagedResponse,
  RecurringIncomeRule,
  RecurringIncomeRulePagedRequest,
  UpsertRecurringIncomeRuleRequest,
} from '@core/models';
import { endpoints, environment } from '@environment';
import { Observable } from 'rxjs';
import { suppressGlobalErrorFeedback } from '@core/interceptors';

@Injectable({ providedIn: 'root' })
export class RecurringIncomeRuleService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiUrl}/${endpoints.v1.recurringIncomeRules}`;

  getAll(includeDisabled = true): Observable<RecurringIncomeRule[]> {
    const params = new HttpParams().set('includeDisabled', includeDisabled);
    return this.http.get<RecurringIncomeRule[]>(this.baseUrl, { params, context: suppressGlobalErrorFeedback() });
  }

  getPaged(
    request: RecurringIncomeRulePagedRequest
  ): Observable<PagedResponse<RecurringIncomeRule>> {
    return this.http.post<PagedResponse<RecurringIncomeRule>>(
      `${this.baseUrl}/paged`,
      request,
      { context: suppressGlobalErrorFeedback() }
    );
  }

  getById(id: string): Observable<RecurringIncomeRule> {
    return this.http.get<RecurringIncomeRule>(`${this.baseUrl}/${id}`, { context: suppressGlobalErrorFeedback() });
  }

  create(payload: UpsertRecurringIncomeRuleRequest): Observable<RecurringIncomeRule> {
    return this.http.post<RecurringIncomeRule>(this.baseUrl, payload, { context: suppressGlobalErrorFeedback() });
  }

  update(id: string, payload: UpsertRecurringIncomeRuleRequest): Observable<RecurringIncomeRule> {
    return this.http.put<RecurringIncomeRule>(`${this.baseUrl}/${id}`, payload, { context: suppressGlobalErrorFeedback() });
  }

  disable(id: string): Observable<RecurringIncomeRule> {
    return this.http.post<RecurringIncomeRule>(`${this.baseUrl}/${id}/disable`, null, { context: suppressGlobalErrorFeedback() });
  }

  enable(id: string): Observable<RecurringIncomeRule> {
    return this.http.post<RecurringIncomeRule>(`${this.baseUrl}/${id}/enable`, null, { context: suppressGlobalErrorFeedback() });
  }
}
